import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import BlockCard from '../../components/Dashboard/CardModal/BlockCard/BlockCard';
import UnblockCard from '../../components/Dashboard/CardModal/UnblockCard/UnblockCard';
import Switch from '@mui/joy/Switch';
import Typography from '@mui/joy/Typography';
import { request } from '../../config';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto'
    },
}));

export default function CreditNotificationModal(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const [feedbackModal, setFeedbackModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);
    const [notification, setNotification] = React.useState(null);

    const close = () => {
        setOpen(false);
        props.onClose();
    }

    const addPaymentNotification = (updatedNotification) => {
        props.updateAppState('isLoadingTransparentBackground', true);
        let addPaymentNotificationRequestBody = {
            ...updatedNotification,
            loanId: props.id,
            token: localStorage.getItem('token'),
        }
        fetch(request("setting/addPaymentNotification", addPaymentNotificationRequestBody))
            .then(res => res.text())
            .then((addPaymentNotificationResponseJSON) => {
                const JSON = require('true-json-bigint');
                let addPaymentNotificationResponse = JSON.parse(addPaymentNotificationResponseJSON);
                if (addPaymentNotificationResponse.status.statusCode !== 1) {
                    if (addPaymentNotificationResponse.status.statusCode === 200) {
                        props.logout();
                    } else {
                        props.alertState(true, 'error', props.t('an error occurred'), props.t(addPaymentNotificationResponse.status.statusCode));
                        props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    setNotification(addPaymentNotificationResponse);
                    props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    props.history.push("/technical-break");
                });
    }

    const getPaymentNotification = () => {
        let getPaymentNotificationRequestBody = {
            loanId: props.id,
            token: localStorage.getItem('token')
        }
        fetch(request("setting/getPaymentNotification", getPaymentNotificationRequestBody))
            .then(res => res.text())
            .then((getPaymentNotificationResponseJSON) => {
                props.updateAppState('isLoadingTransparentBackground', false);
                const JSON = require('true-json-bigint');
                let getPaymentNotificationResponse = JSON.parse(getPaymentNotificationResponseJSON);
                if (getPaymentNotificationResponse.status.statusCode !== 1) {
                    setNotification(null);
                }
                else {
                    setNotification(getPaymentNotificationResponse);
                }
                setOpen(true)
            },
                (error) => {
                    props.history.push("/technical-break");
                });
    }

    useEffect(() => {
        if (props.open === true) {
            getPaymentNotification();
        }
    }, [props.open])

    return (
        <Modal
            open={open}
            onClose={close}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            classes={classes.modal}
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description">
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className="block-card-section-modal">
                        <button className="block-card-section-modal-close-button" onClick={close}>
                            <svg className="block-card-section-modal-close-button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.67762 7.97496L14.8357 2.86698L15.8873 1.81534C16.0376 1.6651 16.0376 1.41471 15.8873 1.2144L14.7856 0.112676C14.5853 -0.0375587 14.3349 -0.0375587 14.1847 0.112676L8.02504 6.32238L1.81534 0.112676C1.6651 -0.0375587 1.41471 -0.0375587 1.2144 0.112676L0.112676 1.2144C-0.0375587 1.41471 -0.0375587 1.6651 0.112676 1.81534L6.32238 7.97496L0.112676 14.1847C-0.0375587 14.3349 -0.0375587 14.5853 0.112676 14.7856L1.2144 15.8873C1.41471 16.0376 1.6651 16.0376 1.81534 15.8873L8.02504 9.67762L13.133 14.8357L14.1847 15.8873C14.3349 16.0376 14.5853 16.0376 14.7856 15.8873L15.8873 14.7856C16.0376 14.5853 16.0376 14.3349 15.8873 14.1847L9.67762 7.97496Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <div className="block-card-section-modal-content">
                            <h3 className="block-card-section-modal-content-title mb-3">{props.t('notifications')}</h3>
                            <Typography component="label" className='d-flex' endDecorator={<Switch sx={{ ml: 1 }} checked={notification?.isActive} onChange={(e) => addPaymentNotification({ isActive: e.target.checked ? 1 : 0 })} />}>
                                Ödəniş bildirişinin göndərilməsi
                            </Typography>
                            {notification?.isActive && <>
                                <p className="block-card-section-modal-content-details pt-4 pb-2 text-left">{props.t('Xatırlatma dövrü')}</p>
                                <form className="block-card-section-modal-content-form">
                                    <ul className="block-card-section-modal-content-form-list">
                                        {notification?.reminderType?.length > 0 && notification.reminderType.map((item) => (
                                            <li className="block-card-section-modal-content-form-list-item">
                                                <span className="block-card-section-modal-content-form-list-item-title">{props.t(item.name)}</span>
                                                <input type="radio" name="card-block-reason" className="block-card-section-modal-content-form-list-item-input" checked={item.active} onChange={(e) => addPaymentNotification({ reminderType: item.value })} />
                                                <span className="block-card-section-modal-content-form-list-item-checkmark"></span>
                                            </li>
                                        ))}
                                    </ul>
                                </form>
                            </>}
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}